type InitProfileState = {
  init?: {
    data?: {
      profile?: {
        role?: {
          type?: string | null
        } | null
      } | null
    } | null
  } | null
}

export function selectInitUserRoleType(state: InitProfileState): string | null {
  const roleType = state.init?.data?.profile?.role?.type
  return typeof roleType === 'string' ? roleType : null
}

export function isSuperAdminRole(roleType: string | null | undefined): boolean {
  return roleType === 'super_admin' || roleType === 'admin'
}

export function selectIsSuperAdmin(state: InitProfileState): boolean {
  return isSuperAdminRole(selectInitUserRoleType(state))
}
